import { ButtonVariant } from "@repo/ui/Buttons/button";
import { IconButton } from "@repo/ui/Buttons/iconButton";
import { Textarea } from "@repo/ui/Inputs/textarea";
import { IconArrowUp, IconTrash } from "@tabler/icons-react";
import type { FC } from "react";

const maxCharactersPerOption = 110;

interface SurveyOptionsEditorProps {
  value: string;
  onChange: (value: string) => void;
  onRemove: () => void;
  onClickReorder: (direction: "up" | "down") => void;
  isDuplicate: boolean;
}

export const SurveyOptionEditor: FC<SurveyOptionsEditorProps> = ({
  value,
  onChange,
  onRemove,
  onClickReorder,
  isDuplicate,
}) => {
  // Handle duplicate options, reordering, and deleting

  return (
    <div className="group relative w-full">
      <div>
        <Textarea
          value={value}
          placeholder="Add a new survey option"
          onChange={onChange}
          maxLength={maxCharactersPerOption}
          shouldDisableNewline
          errorDescription={
            isDuplicate ? "Duplicate options aren't allowed." : ""
          }
          autoFocus={!value} // Auto-focus if input is empty (when adding new value)
        />
      </div>
      <div className="absolute top-1/2 right-2 -translate-y-1/2 transform space-x-2 opacity-0 group-hover:opacity-100">
        <IconButton
          variant={ButtonVariant.Secondary}
          icon={<IconArrowUp className="h-4 w-4" />}
          onClick={() => {
            onClickReorder("up");
          }}
          excludeFromTabOrder
        />
        <IconButton
          variant={ButtonVariant.Secondary}
          icon={<IconArrowUp className="h-4 w-4 rotate-180 transform" />}
          onClick={() => {
            onClickReorder("down");
          }}
          excludeFromTabOrder
        />
        <IconButton
          variant={ButtonVariant.Secondary}
          icon={<IconTrash className="h-4 w-4" />}
          onClick={onRemove}
          excludeFromTabOrder
        />
      </div>
    </div>
  );
};
